import { styled } from '../lib/styles';
export const DayColumnWrapper = styled.div.withConfig({
  displayName: "DayColumnStyles__DayColumnWrapper",
  componentId: "sc-1cpyatw-0"
})(["display:flex;height:100%;position:absolute;width:100%;"]);
export const DayColumn = styled.div.withConfig({
  displayName: "DayColumnStyles__DayColumn",
  componentId: "sc-1cpyatw-1"
})(({
  theme: {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      }
    }
  }
}) => `
  flex: 1 1 auto;
  padding-top: calc(${hourHeight} / 2);
  padding-bottom: calc(${hourHeight} / 2);
  position: relative;
`);